type CollectionImageCache = {
  width: number
  url: string
}

const RECORD_LIMIT = 50

const cache = new Map<string, CollectionImageCache>()
const keyCreationOrder: string[] = []

const has = (key: string) => cache.has(key)

const set = (key: string, value: CollectionImageCache) => {
  if (keyCreationOrder.includes(key)) {
    keyCreationOrder.splice(keyCreationOrder.indexOf(key), 1)
  }

  keyCreationOrder.push(key)

  if (cache.size >= RECORD_LIMIT) {
    const oldestKey = keyCreationOrder.shift()

    if (oldestKey) {
      cache.delete(oldestKey)
    }
  }

  cache.set(key, value)
}

const get = (key: string) => cache.get(key)
const remove = (key: string) => cache.delete(key)

export const clear = () => {
  for (const { url } of cache.values()) {
    URL.revokeObjectURL(url)
  }

  cache.clear()
}

export default () => ({
  set,
  has,
  get,
  remove,
  clear,
})
